'use client';

import HomePageClient from './components/home-page-client';

export default function HomePage() {
  return <HomePageClient />;
}

